import { SceneContainer } from "GameObjects/StoryGame/SceneContainer";
import { SceneSprite } from "GameObjects/StoryGame/SceneSprite";
import { Elastic, Expo, TimelineLite, TweenLite, TweenMax } from "gsap";
import * as HLF from "html-living-framework";
import { Application } from "Singletons/Application";
import { AbstractStoryState } from "States/AbstractStoryState";
import * as Constants from "Data/Constants";

import {hh_ch2_72dpi_p02} from "../../../layouts/ch2_p02/hh_ch2_72dpi_p02"

export class Chapter2Page2 extends AbstractStoryState {

	readonly bg = this.addChild(new SceneSprite());
	readonly holly = this.addChild(new SceneSprite());
	readonly chairsBack = this.addChild(new SceneSprite());
	readonly piper = this.addChild(new SceneSprite());
	readonly table = this.addChild(new SceneSprite());
	readonly oscar = this.addChild(new SceneSprite());
	readonly amy = this.addChild(new SceneSprite());
	readonly chairsFront = this.addChild(new SceneSprite());
	readonly frameLeft = this.addChild(SceneSprite.withPrefix("ch2_p02/"));
	readonly frameRight = this.addChild(SceneSprite.withPrefix("ch2_p02/"));
	readonly linesLeft = this.addChild(SceneSprite.withPrefix("ch2_p02/"));
	readonly linesRight = this.addChild(SceneSprite.withPrefix("ch2_p02/"));

	protected dontScaleUp = true;

    public init(pSize: PIXI.Point, pData: any) {
		// exported layout from Animate CC
		hh_ch2_72dpi_p02.call(this);

        // interaction

		// super.init calls onResize
		super.init(pSize, pData);
	}

	public update(pDeltaTime: number) {
		super.update(pDeltaTime);
	}

	public animateIn(pOnComplete: ()=>void) {
		super.animateIn(pOnComplete);
	}

	public onAnimateInComplete() {
		super.onAnimateInComplete();
		TweenLite.delayedCall(1.5, ()=>this.gotoNextState({transition: "up"}));
	}
}